export interface MappingItem {
  id: string;
  soId: string;
  soNumber: string;
  itemDescription: string;
  status: 'unmapped' | 'in_progress' | 'mapped';
  delayHours: number;
  poId: string | null;
  poNumber: string | null;
  confirmedAt: string | null;
}

export interface PO {
  id: string;
  number: string;
  status: string;
  vendor?: { name: string } | null;
}

export function formatStatus(s: string) {
  return s.split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
}

